import { EventGroup as GQLItem } from '../../generated/graphql';
import * as Event from '../../events/Event';
import { take } from '../../util';

/**
 * Legacy leaf. The hold API that used to live alongside this model moved to
 * `src/api/App/EventGroup/`; this file survives only because `src/events/Event.ts` — itself still
 * legacy — maps its `eventGroup` association through it. Retire it with `src/events/Event.ts`.
 */
export type EventGroup = {
  id: number;
  name: string;
  events: Event.EventType[];
};

export const fromGql = (item: GQLItem): EventGroup => ({
  ...take(item, 'id', 'name'),
  events: item.events?.map(Event.fromGql) || [],
});
